import { CentroCusto } from './../../../../comercial/domain/models/centro_custo';
import { IGetReportRateioGeralListaUseCase } from "../../../presentation/useCases/read/get_report_rateio_geral_use_case";
import { IReportsRepository } from "../../repositories/reports_repository";
import { downloadBase64File } from "../../../../../common/utils/download_utils";
import dayjs from "dayjs";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { ReportData } from "../../models/report_data";

/**
 * GetReportRateioGeralListaUseCase
 */

export type GetReportRateioGeralListaParams = {
  requiredMimeType: ReportMimeType | null,
  numeroConta?: string | null;
  centroCustos?: number[] | null;
  fornecedores?: number[] | null;
  ordemCompras?: number[] | null;
  medicoes?: number[] | null;
  funcionarios?: number[] | null;
  valorPago?: number | null;
  dataDe?: Date | null;
  dataAte?: Date | null;
  idUsuario?: number | null;

};


export class GetReportRateioGeralListaUseCase implements IGetReportRateioGeralListaUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async execute(params: GetReportRateioGeralListaParams): Promise<ReportData> {

    const centroCustoStr = params.centroCustos ? params.centroCustos.filter(x => x !== 0).join(',') : null;
    const fornecedoresStr = params.fornecedores ? params.fornecedores.filter(x => x !== 4).join(',') : null;
    const ordemComprasStr = params.ordemCompras ? params.ordemCompras.filter(x => x !== 0).join(',') : null;
    const medicoesStr = params.medicoes ? params.medicoes.filter(x => x !== 0).join(',') : null;
    const funcionariosStr = params.funcionarios ? params.funcionarios.filter(x => x !== 0).join(',') : null;

    const response = await this.repository.getReportRateioGeralLista(
      params.requiredMimeType ?? "text/html",
      params.numeroConta,
      centroCustoStr,
      fornecedoresStr,
      ordemComprasStr,
      medicoesStr,
      funcionariosStr,
      params.valorPago ?? null,
      params.dataDe ?? null,
      params.dataAte ?? null,
      params.idUsuario ?? null
    );


    if (response.mimeType !== "text/html") {
      const arquivoData = response.bytes;
      const arquivoNome = `rateio_geral_lista_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;

      await downloadBase64File(arquivoNome, arquivoData);
    }

    return response;

  }
}